import { jsx } from '@emotion/react'
export default function RowComponent({ as, ...rest }) {
  return jsx(as, {
    css: [
      {
        padding: 0,
        margin: 0
      }
    ],
    ...rest
  })
}
